// Краткие требования к камерам по порядку: первая и вторая
export const CAMERA_HINTS = [
  'экран, руки и профиль участника',
  'либо лицо участника, либо профиль с другой стороны',
];

// Плашка «микрофон или звук молчат»: текст по виду беды, кнопка одна
export const MIC_ISSUE_TEXTS = {
  gesture: 'Микрофон молчит: браузер ждет вашего нажатия.',
  lost: 'Микрофон занят другим приложением.',
} as const;
export const AUDIO_BLOCKED_TEXT = 'Звук отключен: браузер ждет вашего нажатия.';
export const AUDIO_AND_MIC_BLOCKED_TEXT = 'Микрофон и звук молчат: браузер ждет вашего нажатия.';

// Серверы видеосвязи: пока один, первый выбран по умолчанию
export const VIDEO_SERVERS = ['https://video1.chessopen.ru'];

// Официальные инструкции браузеров, как разрешить сайту камеру и микрофон (см. PERMISSIONS.md)
export const PERMISSIONS_HELP = {
  chrome: 'https://support.google.com/chrome/answer/2693767?hl=ru',
  chromeAndroid:
    'https://support.google.com/chrome/answer/2693767?hl=ru&co=GENIE.Platform%3DAndroid',
  chromeIos: 'https://support.google.com/chrome/answer/2693767?hl=ru&co=GENIE.Platform%3DiOS',
  firefox: 'https://support.mozilla.org/ru/kb/how-manage-your-camera-and-microphone-permissions',
  safariMac: 'https://support.apple.com/ru-ru/guide/safari/ibrw7f78f7fe/mac',
  safariIos: 'https://support.apple.com/ru-ru/guide/iphone/iph168c4bbd5/ios',
  edge: 'https://support.microsoft.com/ru-ru/windows/privacy/windows-camera-microphone-and-privacy',
  yandex: 'https://yandex.ru/support/browser/personal-data-protection/do-not-follow.html',
  opera: 'https://help.opera.com/ru/latest/web-preferences/',
  // уровень системы: браузер заблокирован в настройках ОС
  macos: 'https://support.apple.com/ru-ru/guide/mac-help/mchlf6d108da/mac',
  windows:
    'https://support.microsoft.com/ru-ru/windows/privacy/windows-camera-microphone-and-privacy',
} as const;

// Браузеры без своей страницы: поиск Google с ответом ИИ по запросу
export const PERMISSIONS_HELP_SEARCH = 'https://www.google.com/search?udm=50&q=';
